/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { MaterialCommunityIcons } from '@expo/vector-icons';

export const ActionIcon = (props: {
  name: any;
  color?: string;
}): JSX.Element => <MaterialCommunityIcons size={24} {...props} />;

ActionIcon.defaultProps = {
  color: undefined
};

export const TabBarIcon = (props: {
  name: any;
  color: string;
}): JSX.Element => (
  <MaterialCommunityIcons
    size={26}
    style={{ marginTop: 8, marginBottom: 5 }}
    {...props}
  />
);
